import gameTitleImage from "app/assets/spellcheck.png";
import formatPublishDate from "app/utils/formatPublishDate";
import useGameData from "app/game-data/useGameData";
import { useGameActionDispatch, useGameState } from "app/game/useGame";
import { GameAction } from "app/game/gameState";
import MenuButton from "app/ui/MenuButton";
import TypoWord from "app/ui/TypoWord";
import { useKey } from "react-use";
import mixpanel from "mixpanel-browser";
import cn from "app/utils/classnames";

export default function TitleScreen() {
  const { id: gameId } = useGameState();
  const dispatch = useGameActionDispatch();

  const data = useGameData();
  const publishDate = data?.publishDate ?? "07-28-1988";
  const constructorName =
    data?.levels[0]?.constructorName ?? "Word Spellingman";

  function handleEnterPressed() {
    mixpanel.track("game_start", { game_id: gameId });
    dispatch({ type: GameAction.TITLE_SCREEN_EXITED });
  }
  useKey("Enter", handleEnterPressed);

  return (
    <div
      className={cn(
        "h-full w-full max-w-3xl mx-auto relative",
        "flex flex-col items-center justify-center gap-5 lg:gap-6 p-7.5 ",
      )}
    >
      <img
        src={gameTitleImage}
        className="flex border border-black rounded-md p-4"
        alt=""
        width={295}
        height={292}
        onLoad={() => {
          mixpanel.track_pageview({
            page: `Game Title Screen`,
            game_id: gameId,
          });
        }}
      />

      <h1
        className={cn(
          "text-center text-[2.5rem] font-bold leading-none -tracking-[0.02em]",
          "border border-black rounded-md",
          "px-12 py-3",
        )}
      >
        Spellcheck
      </h1>

      <p
        className={cn(
          "max-w-md px-2",
          "text-center text-lg font-bold uppercase leading-[1.38] tracking-[0.03em]",
        )}
      >
        <TypoWord word="Expand" /> <TypoWord word="your" />{" "}
        <TypoWord word="vocabulary" /> and spell <TypoWord word="words" /> that{" "}
        <TypoWord word="refresh" /> <TypoWord word="daily" />.
      </p>

      {publishDate && (
        <div className="flex flex-col items-center gap-3 lg:gap-4">
          <MenuButton
            className={cn(
              "px-8 max-w-30",
              "text-lg font-mono uppercase",
              "flex justify-center",
            )}
            onClick={() => {
              mixpanel.track("game_start", { game_id: gameId });
              dispatch({ type: GameAction.TITLE_SCREEN_EXITED });
            }}
          >
            <TypoWord word="Play" /> Now
          </MenuButton>
          <p className="text-center text-sm tracking-[-0.015em] lg:text-base">
            {`By ${constructorName} - ${formatPublishDate(publishDate)}`}
          </p>
        </div>
      )}
      <p className="mt-auto text-sm">
        Based on a concept by{" "}
        <a
          href="https://www.youtube.com/watch?v=KK3mS4bQ5JM"
          className="underline font-semibold"
          target="_blank"
          rel="noopener noreferrer"
        >
          Answer in Progress
        </a>
        .
      </p>
    </div>
  );
}
